import { api } from "../lib/axios";

import type { ApiData, Meta } from "./apiData";
import type { Space } from "../types/space";

type ListUserSpacesResponse = ApiData<Array<Space>> & Meta

async function listUserSpaces() {
    const response = await api<ListUserSpacesResponse>('user/spaces')

    return response.data
}

export { listUserSpaces }